import React from "react";

const Police = ()=>{

    return(
        <div className="regulations-detail" >
            <div>
                <div className="box-list-style">Chính sách bảo mật này được đưa ra để thể hiện vai trò của chúng tôi trong việc bảo vệ hệ thống dữ liệu và nâng cao Dịch vụ khách hàng.</div>
                <ul className="pdl-20">
                    <li>Chúng tôi cam kết xử lý thông tin của Quý khách bằng tính trung thực và tinh thần trách nhiệm cao nhất, điều mà chúng tôi đã thể hiện xuyên suốt trong quá trình phát triển của Công ty Cổ phần Bibo Mart TM.</li>
                    <li>Khi truy cập Website và App Bibo Mart đồng nghĩa với việc Quý khách đã đồng ý chấp nhận thực hiện những điều khoản và điều kiện trong Chính sách bảo mật thông tin này.</li>
                    <li>Nếu quý khách không đồng ý với các điều khoản và điều kiện của Chính sách bảo mật thông tin này, vui lòng không sử dụng hệ thống website và app của Bibo Mart.</li>
                </ul>
                </div>
                <div>
                <div >
                    <b className="index">1. Mục đích và phạm vi thu thập thông tin</b>
                </div>
                <div >
                    <div className="box-list-style">
                    <b>Việc thu thập thông tin qua website và app Bibo Mart nhằm mục đích:</b>
                    <ul className="pdl-20" >
                        <li>Giúp chúng tôi hiểu được nhu cầu, sở thích của Khách hàng nhằm nâng cao chất lượng dịch vụ dành cho Khách hàng.</li>
                        <li>Thấu hiểu để chia sẻ thông tin về về Chính sách, Cẩm nang, Khuyến mại, Sự kiện ... phù hợp nhất cho từng Khách hàng.</li>
                        <li>Hỗ trợ khách hàng giải quyết khiếu nại, dịch vụ hậu mãi nhanh chóng nhất.</li>
                    </ul>
                    </div>
                    <div className="box-list-style">
                    <b>Các thông tin Bibo ghi nhận bao gồm:</b>
                    <ul className="pdl-20" >
                        <li>Thông tin cá nhân khai báo bởi người sử dụng khi đăng ký tài khoản web/app: Họ tên, số điện thoại, địa chỉ email, địa chỉ, số con, ngày sinh...</li>
                        <li>Thông tin Khách hàng cung cấp khi đặt hàng , tham gia các sự kiện online & offline.</li>
                        <li>Thông tin ghi nhận khi Khách hàng chủ động điền phiếu khảo sát, gửi email hoặc gọi đến tổng đài của Bibo Mart, tương tác qua các nền tảng mạng xã hội (facebook, tiktok...)</li>
                        <li>Thông tin Khách hàng cung cấp khi đặt mua hàng: Địa chỉ giao hàng, Phương thức thanh toán và Thông tin thanh toán.</li>
                        <li>Trong trường hợp Quý khách hàng chọn phương thức thanh toán trực tuyến qua các nền tảng thanh toán trực tuyến như VNPay, Momo, ZaloPay... (gồm Thanh toán quét mã QR, Thẻ ATM và tài khoản ngân hàng, Thẻ thanh toán quốc tế) thì các thông tin liên quan đến ứng dụng Mobile Banking, Internet Banking, Thông tin Thẻ thanh toán ... không phải là thông tin mà Bibo Mart thu thập.</li>
                    </ul>
                    </div>
                </div>
                </div>
                <div>
                <div >
                    <b className="index">2. Cam kết bảo mật và sử dụng thông tin</b>
                </div>
                <div >
                    <div className="box-list-style" >
                    <u>Cam kết bảo mật thông tin của Bibo Mart:</u>
                    <ul className="pdl-20">
                        <li>Bibo luôn coi trọng việc bảo mật thông tin Khách hàng và cam kết không tự ý sử dụng thông tin Khách hàng với mục đích không mang lại lợi ích cho Khách hàng.</li>
                        <li>Chúng tôi cam kết không trao đổi mua bán thông tin Khách hàng vì mục đích thương mại.</li>
                        <li>Mọi sự chia sẻ và sử dụng thông tin khách hàng chúng tôi cam kết thực hiện theo sự đồng thuận với Khách hàng và Quy định pháp luật.</li>
                        <li>Chúng tôi cam kết nỗ lực cao nhất để bảo vệ sự riêng tư của Quý khách khi sử dụng dịch vụ của Bibo Mart.</li>
                    </ul>
                    </div>
                    <div className="box-list-style" >
                    <u>Khuyến cáo với Khách hàng:</u>
                    <ul className="pdl-20" >
                        <li>Để bảo mật thông tin cá nhân của Quý khách, chúng tôi khuyến cáo Quý khách hạn chế truy cập tài khoản bằng đăng nhập tự động</li>
                        <li>Chú ý không để chế độ tự động lưu password và đảm bảo luôn đăng xuất khỏi tài khoản khi sử dụng máy tính và các thiết bị liên lạc cá nhân dùng chung để bảo vệ tài khoản app/web của Quý khách.</li>
                        <li>Chúng tôi sẽ không chịu trách nhiệm khi những thông tin cá nhân của Quý khách bị rò rỉ vì những lý do trên.</li>
                    </ul>
                    </div>
                    <div>
                    <u>Các trường hợp đặc biệt cần chia sẻ thông tin:</u>
                    <div className="box-list-style">Thông tin của Khách hàng chỉ được chia sẻ trong một số trường hợp đặc biệt như sau:</div>
                    <ul className="pdl-20" >
                        <li>Được sự đồng ý của Khách hàng.</li>
                        <li>Theo yêu cầu của cơ quan chức năng Nhà nước.</li>
                        <li>Chia sẻ số điện thoại đặt hàng và địa chỉ nhận hàng cho Nhân viên giao nhận để liên hệ giao hàng.</li>
                    </ul>
                    </div>
                </div>
                </div>
                <div>
                <div >
                    <b className="index">3. Cập nhật và lưu trữ thông tin</b>
                </div>
                <div className="box-list-style" >
                    <ul className="pdl-20" >
                    <li>Khách hàng có thể chỉnh sửa dữ liệu cá nhân của mình qua mục “Tài khoản" trên App hoặc gọi điện đến Hotline 1800 6886 để được hỗ trợ.</li>
                    <li>Bibo Mart sẽ lưu trữ Khách hàng trong suốt quá trình cung cấp dịch vụ cho Khách hàng.</li>
                    </ul>
                </div>
                </div>
                <div>
                <div>
                    <b className="index">4. Điều chỉnh và áp dụng</b>
                </div>
                <div className="box-list-style">
                    <ul className="pdl-20">
                    <li>Chính sách bảo mật này chỉ áp dụng cho Khách hàng của Bibo Mart.</li>
                    <li>Các điều khoản của Chính sách này có thể được điều chỉnh theo quy định của pháp luật nhằm đảm bảo tuân thủ pháp luật và theo thực tế hoạt động của Bibo nhằm nâng cao quyền lợi của Khách hàng.</li>
                    <li>Bibo có toàn quyền điều chỉnh Chính sách này mà không thông báo trước.</li>
                    <li>Vui lòng kiểm tra email, website và app thường xuyên để cập nhật các thay đổi (nếu có) của Chính sách này.</li>
                    </ul>
                </div>
            </div>
            
        </div>
    )
}
export default Police;